module.exports = __webpack_public_path__ + "assets/img/tj_head_back_right.d2d9e60e.png";